import { select, put } from 'redux-saga/effects';
import { getCountryAndCurrencyData } from '../utils/countryUtils';
import { updateCountryAndCurrency } from '../actions/headerActions';

export function* updateHeaderSaga(countryCode, currency) {
    const state = yield select();
    const data = getCountryAndCurrencyData(state, countryCode, currency);

    if (data && _.size(data) > 0) {
        yield put(updateCountryAndCurrency(data.country,
            data.currency, data.countryDisplayName, data.currencyFormattingInfo));
    }
}
